var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Box, Grid, makeStyles, Paper } from '@material-ui/core';
import React from 'react';
import { CharacterItem } from './character-item';
var useStyles = makeStyles(function (_a) {
    var spacing = _a.spacing;
    return ({
        root: {
            maxHeight: '100%',
            backdropFilter: 'blur(2px)',
            pointerEvents: 'all'
        },
        background: {
            position: 'absolute',
            left: 0,
            right: 0,
            bottom: 0,
            top: 0,
            opacity: 0.5,
            zIndex: -1
        },
        content: {
            padding: spacing(2),
            overflowY: 'auto',
            overflowX: 'hidden'
        }
    });
});
export var CharacterListPanel = function (_a) {
    var characterMap = _a.characterMap, characterList = _a.characterList, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onClick = _a.onClick;
    var classes = useStyles();
    return (React.createElement(Box, { className: classes.root, position: 'relative', display: 'inline-flex', zIndex: 0 },
        React.createElement(Paper, { className: classes.background }),
        React.createElement("div", { className: classes.content },
            React.createElement(Grid, { container: true, direction: 'column', wrap: 'nowrap', spacing: 1 }, characterList.map(function (characterId) { return (React.createElement(Grid, { key: characterId, item: true },
                React.createElement(CharacterItem, __assign({}, characterMap[characterId], { onMouseEnter: function () { return onMouseEnter(characterId); }, onMouseLeave: onMouseLeave, onClick: function () { return onClick(characterId); } })))); })))));
};
